import { css } from 'lit';

export default [
  css`
  select {
    background: var(--tenable-input-background, #ffffff);
    width: var(--tenable-input-width, 100%);
    border: var(--tenable-input-border, 1px solid #ccc);
    border-radius: var(--tenable-input-border-radius, 0);
    padding: var(--tenable-input-padding, .5rem);
    height: var(--tenable-input-height, 2.5rem);
    display: var(--tenable-input-display, block !important);
    box-shadow: var(--tenable-input-box-shadow, inset 0 1px 2px #0000000d);
    font: var(--tenable-input-font, inherit);
    line-height: var(--tenable-input-line-height, normal);
    box-sizing:  var(--tenable-input-box-sizing, border-box);
  }

  select[multiple] {
    height: auto;
  }

  select:focus {
    border-color: var(--tenable-input-focus-border-color, #1E2426);
    box-shadow: var(--tenable-input-focus-box-shadow, 0 0 0 .15rem rgba(13,110,253,.25));
    outline: 0;
  }

  select.invalid {
    border-color: var(--tenable-input-invalid-border-color, #9C2121);
  }

  select.placeholder {
    color: var(--tenable-input-placeholder-color, #5B6062);
  }

  label {
    margin: var(--tenable-label-margin, 0 0 .25rem);
    display: block;
    font-weight: var(--tenable-label-font-weight, 600);
    color: var(--tenable-label-color, #5B6062);
  }

  /* Floating Label */
  .form-floating {
    position: relative;
  }

  .form-floating label {
    display: inline-block;
    position: absolute;
    top: var(--tenable-input-padding, .5rem);
    left: var(--tenable-input-padding, .75rem);
    pointer-events: none;
    transition: all .1s ease-in-out;
    color: var(--tenable-input-placeholder-color, var(--tenable-text-color, #5B6062));
    font-weight: var(--tenable-input-placeholder-font-weight, 400);
  }

  .form-floating select {
    font-size: 1rem;
    padding: 0.85rem 0.75rem 0.35rem;
    color: var(--tenable-text-color, #5B6062);
  }

  .form-floating select + label:not(.blank-placeholder),
  .form-floating select:focus + label {
    font-size: .75rem;
    transform: translate(0, -.50rem);
    color: var(--tenable-label-floating-color, #5B6062);
  }
  `,
];
